import * as documentTypes from '../../constants/documentTypes/documentTypes';
import { ReactComponent as IconCar } from '../../icons/car.svg';
import { ReactComponent as IconClipboard } from '../../icons/clipboard.svg';
import { ReactComponent as IconGrid } from '../../icons/grid.svg';
import { ReactComponent as IconHouseSimple } from '../../icons/house-simple.svg';
import { ReactComponent as IconHouse } from '../../icons/house.svg';
import { ReactComponent as IconInfo } from '../../icons/info.svg';
import { ReactComponent as IconMailOpen } from '../../icons/mail-open.svg';
import { ReactComponent as IconParcel } from '../../icons/parcel.svg';
import { ReactComponent as IconSearch } from '../../icons/search.svg';
import { ReactComponent as IconShipment } from '../../icons/shipment.svg';

export const routeIconMapper = {
	[documentTypes.frontpage]: IconHouse,
	[documentTypes.styleguide]: IconHouse,
	[documentTypes.articles]: IconParcel,
	[documentTypes.articleYear]: IconParcel,
	[documentTypes.article]: IconParcel,
	[documentTypes.events]: IconClipboard,
	[documentTypes.event]: IconClipboard,
	[documentTypes.contentSite]: IconInfo,
	[documentTypes.openingHours]: IconHouse,
	[documentTypes.registerShipment]: IconShipment,
	[documentTypes.postboxPromo]: IconParcel,
	[documentTypes.trackShipment]: IconCar,
	[documentTypes.search]: IconSearch,
	[documentTypes.sendReceipt]: IconClipboard,
	[documentTypes.sendReceiptMultistep]: IconClipboard,
	[documentTypes.generalPostInfo]: IconHouse,
	[documentTypes.registerShipmentCalculator]: IconMailOpen,
	[documentTypes.priceListGroup]: IconGrid,
	[documentTypes.menuGroup]: IconHouse,
	[documentTypes.menuSubGroup]: IconHouseSimple,
};
